import { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import {
    getProcessButtons, getError, getImageCircularGenericNew, getItemStatsHtml, isUndNullEmpNew, itemsLocal,
    sendMessageCloseCurrentWindow, sendMessageNew, setSeparatorsNumbersNew, settings, validateDecimals, getLanguageObj, getResponse
} from '../../helpers/UtilsHelper';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { AuthContextType } from '../../auth/AuthContext';
import { ItemService } from '../../services/items/ItemService';

const { app, icons, images, messages, labels, mercadoLibre: mercadoLibreSettings, firebase } = settings;
const { fields: dbFields } = firebase?.firestore || {};

const currentMethod = 'ItemEdit - function';

export default function ItemEdit({
    processValues = {},
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const {
        $ = {},
        auth = AuthContextType,
        item = {},
        setItem = () => { },
        dtId = '',
        dtRowId = '',
        showModal = false,
        setShowModal = () => { },
        formData = {},
        showAlertDelete = false,
        setShowAlertDelete = () => { },
        showAlert = false,
        isReadOnly = false,
    } = processValues;

    const [errors, setErrors] = useState({
        title: '',
        availableQuantity: '',
        priceOtherCurrency: '',
    });
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
    });

    const [btnSaveDisabled, setBtnSaveDisabled] = useState(false);
    const [readOnlyAvailableQuantity, setReadOnlyAvailableQuantity] = useState(false);
    const [itemEditDescription, setItemEditDescription] = useState('');
    const [itemPicture, setItemPicture] = useState('');
    const isMount = useRef(true);

    let itemStatus = [];
    if (!isUndNullEmpNew({ data: item, subMethod: currentMethod })?.result) {
        if (item?.mlStatus === mercadoLibreSettings?.status.under_review) {
            itemStatus = [
                { id: mercadoLibreSettings?.status.deleted, description: mercadoLibreSettings?.status.deleted },
                { id: mercadoLibreSettings?.status.under_review, description: mercadoLibreSettings?.status.under_review },
            ];
        } else {
            itemStatus = [
                { id: mercadoLibreSettings?.status.active, description: mercadoLibreSettings?.status.active },
                { id: mercadoLibreSettings?.status.closed, description: mercadoLibreSettings?.status.closed },
                { id: mercadoLibreSettings?.status.deleted, description: mercadoLibreSettings?.status.deleted },
                { id: mercadoLibreSettings?.status.paused, description: mercadoLibreSettings?.status.paused },
            ];
        }
    }
    //#endregion variables

    //#region methods
    const editItem = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editItem';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            const processedItem = response?.result?.item || item;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            response = await ItemService.edit({
                item: processedItem,
                token: auth?.account?.tokenVzLaML?.token,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            const updatedItemResult = response?.result;
            if (updatedItemResult) {
                setItem(updatedItemResult);
            }

            const newPriceLocal = getNewPrice({
                priceOtherCurrency: processedItem?.priceOtherCurrency,
                rate: formData?.rate,
                subMethod: currentMethod,
            })?.result;

            const priceOtherCurrencyFormatted = setSeparatorsNumbersNew({ number: processedItem?.priceOtherCurrency, withDecimals: true, subMethod: currentMethod })?.result;
            const newPriceFormatted = setSeparatorsNumbersNew({ number: newPriceLocal, withDecimals: true, subMethod: currentMethod })?.result;
            const priceFormatted = setSeparatorsNumbersNew({ number: processedItem?.price, withDecimals: true, subMethod: currentMethod })?.result;

            const dtRow = [
                getImageCircularGenericNew({
                    alt: 'accountImage', src: processedItem?.picture,
                    subMethod: currentMethod
                })?.result,
                processedItem?.title,
                `${getItemStatsHtml({ data: processedItem?.status })}`,
                `${priceOtherCurrencyFormatted}`,
                `${newPriceFormatted} <i class='${setComparatorPrices({
                    newPriceLocal: newPriceLocal,
                    priceLocal: processedItem?.price,
                    subMethod: currentMethod,
                })}'></i>`,
                `${priceFormatted}`,
                getProcessButtons({
                    id: processedItem?.id,
                    description: processedItem?.title,
                    detailsShow: false,
                    detailsLabel: '',
                    detailsEnabled: false,
                    editShow: true,
                    editLabel: labels?.edit?.[languageObj?.id],
                    editEnabled: true,
                    deleteShow: false,
                    deleteLabel: '',
                    deleteEnabled: false,
                    processButtons: [],
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                })?.result,
                processedItem?.itemId,
            ];

            $(`#${dtId}`).DataTable().row(dtRowId).data(dtRow).draw();

            response.msgText = messages?.processCompletedSuccessfully?.[languageObj?.id];
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const formDataValidate = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const errors_ = { title: '', availableQuantity: '', priceOtherCurrency: '' };
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];

            let itemCopy = { ...item };

            if (isUndNullEmpNew({ data: itemCopy?.title, subMethod: currentMethod })?.result) {
                errors_.title = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: itemCopy?.status, subMethod: currentMethod })?.result) {
                errors_.title = thisFieldRequired;
                response = getResponse({ type: 1 });
            } else if (itemCopy?.status !== mercadoLibreSettings?.status.closed &&
                itemCopy?.status !== mercadoLibreSettings?.status.deleted) {
                if (itemCopy?.priceOtherCurrency !== null && itemCopy?.priceOtherCurrency >= 0) {
                    if (isNaN(itemCopy?.priceOtherCurrency) || itemCopy?.priceOtherCurrency.toString().split('.').length > 2) {
                        errors_.priceOtherCurrency = messages?.youMustEnterOnlyNumbersAndDot?.[languageObj?.id];
                        response = getResponse({ type: 1 });
                    }
                } else {
                    errors_.priceOtherCurrency = messages?.youMustGreaterThanOrEqualToZero?.[languageObj?.id];
                    response = getResponse({ type: 1 });
                }

                if (itemCopy?.availableQuantity > 0) {
                    if (isNaN(itemCopy?.availableQuantity) || itemCopy?.availableQuantity.toString().split('.').length > 2) {
                        errors_.availableQuantity = messages?.youMustEnterOnlyNumbersAndDot?.[languageObj?.id];
                        response = getResponse({ type: 1 });
                    }
                } else {
                    errors_.availableQuantity = messages?.youMustGreaterThanOrEqualToZero?.[languageObj?.id];
                    response = getResponse({ type: 1 });
                }
            }

            setErrors(errors_);

            if (response?.isWarning) {
                response.isSuccess = false;
            } else {
                itemCopy.description = { ...itemCopy.description, plain_text: itemEditDescription };
                delete itemCopy.variations;
                itemCopy.availableQuantity = parseFloat(itemCopy.availableQuantity);
                itemCopy.priceOtherCurrency = parseFloat(itemCopy.priceOtherCurrency);
                response.result = { item: itemCopy };
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const getNewPrice = ({
        priceOtherCurrency = 0.00,
        rate = 0.00,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getNewPrice';
        let response = getResponse({ type: 0 });
        try {
            response.result = (priceOtherCurrency * rate).toFixed(settings?.numberPositions?.decimalsPlace);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            response.result = 0.00;
        }
        return response;
    };

    const setComparatorPrices = ({
        newPriceLocal = 0.00,
        priceLocal = 0.00,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setComparatorPrices';
        let response = getResponse({ type: 0 });
        try {
            newPriceLocal = parseFloat(newPriceLocal);
            priceLocal = parseFloat(priceLocal);

            if (newPriceLocal === priceLocal) {
                return `${icons?.fasFa?.equals} text-primary`;
            } else if (newPriceLocal > priceLocal) {
                return `${icons?.fasFa?.arrowUp} text-success`;
            } else if (newPriceLocal < priceLocal) {
                return `${icons?.fasFa?.arrowDown} text-warning`;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console.log(response);
        }
        return '';
    };

    const setItemDataField = ({
        key = '',
        value = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setItemDataField';
        let response = getResponse({ type: 0 });
        try {
            setItem(prev => ({ ...prev, [key]: value }));
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            sendMessageNew({
                msgType: response?.msgType,
                msgText: response?.msgText,
                timer: 0,
                confirmButton: true,
                timerProgressBar: false,
                languageId: languageObj?.id,
            });
        }
    };

    const changeItemStatus = ({
        statusType = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'changeItemStatus';
        let response = getResponse({ type: 0 });
        try {
            setBtnSaveDisabled(false);

            if (statusType === mercadoLibreSettings?.status.under_review) {
                setBtnSaveDisabled(true);
                sendMessageNew({ msgType: 1, msgText: messages?.youCanNotAssingTheStatus({ statusType: statusType, languageId: languageObj?.id }), timer: 0, confirmButton: true, timerProgressBar: false, languageId: languageObj?.id });
            } else {
                if ((item?.mlStatus !== mercadoLibreSettings?.status.closed && statusType !== mercadoLibreSettings?.status.under_review) ||
                    (item?.mlStatus === mercadoLibreSettings?.status.closed && (statusType === mercadoLibreSettings?.status.active || statusType === mercadoLibreSettings?.status.deleted || statusType === mercadoLibreSettings?.status.closed))) {

                    let updatedItem = { ...item, status: statusType };

                    if (updatedItem?.listingTypeId !== 'free') {
                        if (statusType === mercadoLibreSettings?.status.active) {
                            setReadOnlyAvailableQuantity(false);
                        } else {
                            setReadOnlyAvailableQuantity(true);
                        }
                    } else {
                        if (statusType === mercadoLibreSettings?.status.active) {
                            updatedItem.availableQuantity = 1.00;
                        }
                        setReadOnlyAvailableQuantity(true);
                    }

                    if (statusType === mercadoLibreSettings?.status.closed) {
                        updatedItem.availableQuantity = 0.00;
                    }

                    setItem(updatedItem);
                } else {
                    setBtnSaveDisabled(true);
                    sendMessageNew({ msgType: 1, msgText: messages?.closedItemCanOnlyBeActivatedOrDeleted?.[languageObj?.id], timer: 0, confirmButton: true, timerProgressBar: false, languageId: languageObj?.id });
                }
            }
            setShowAlertDelete(statusType === mercadoLibreSettings?.status.deleted);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console.log(response);
        }
    };

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            const itemDescription = item?.description || itemsLocal?.description;
            let disableLocal = item?.status === mercadoLibreSettings?.status.paused ||
                item?.status === mercadoLibreSettings?.status.closed;

            setBtnSaveDisabled(disableLocal);
            setItemEditDescription(!isUndNullEmpNew({ data: itemDescription, subMethod: currentMethod })?.result ? itemDescription?.plain_text : '');
            setReadOnlyAvailableQuantity(item?.listingTypeId === 'free' || disableLocal);

            setItemPicture(
                item?.picture ||
                `${app?.url}${images?.noImage}`
            );
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            setShowModal(false);
        } finally {
            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} backdrop='static' centered contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='itemLogo' src={images?.itemsLogo} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.item?.[languageObj?.id] || 'Item'}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className='badge badge-pill py-1 px-2 text-uppercase badge-warning text-dark'
                            style={settings?.html?.badges?.micro}>
                            {labels?.edit?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={(e) => editItem({ e: e, subMethod: 'onSubmit - form' })}>
                <Modal.Body className='px-4 pt-2'>
                    <div className='text-center mb-4 mt-2'>
                        <img alt='itemImage' className='img-circle shadow-sm border' src={itemPicture} style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                        <h6 className='mt-3 mb-1 font-weight-bold text-dark'>{labels?.image?.[languageObj?.id]}</h6>
                        {/* <small className='text-muted d-block'>{sale?.order_items?.[0]?.item?.id}</small> */}
                    </div>
                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.title?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.spellCheck} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                title={labels?.title?.[languageObj?.id]}
                                type='text'
                                onChange={(e) => setItemDataField({ key: dbFields?.title, value: e?.target?.value, subMethod: 'inputTitle', })}
                                onFocus={() => setErrors(prev => ({ ...prev, title: '' }))}
                                placeholder={labels?.title?.[languageObj?.id]}
                                readOnly={isReadOnly}
                                disabled={process?.showLoading}
                                value={item?.title || ''} />
                        </div>
                        {errors?.title && <div className={settings?.html?.errorText}>{HtmlParser(errors?.title || '')}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.description?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.spellCheck} position-absolute input-icon-left`} style={{ top: '25px' }} />
                            <textarea className='form-control border-0 shadow-sm form-input-icon'
                                rows='3'
                                style={{ height: 'auto', paddingTop: '15px' }}
                                title={labels?.description?.[languageObj?.id]}
                                onChange={(e) => setItemEditDescription(e?.target?.value)}
                                placeholder={labels?.description?.[languageObj?.id]}
                                readOnly={isReadOnly}
                                disabled={process?.showLoading}
                                value={itemEditDescription}>
                            </textarea>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12 col-md-6'>
                            <div className='form-group mb-4'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.priceOtherCurrency?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.moneyCheckAlt} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon text-right'
                                        autoFocus={true}
                                        title={labels?.priceOtherCurrency?.[languageObj?.id]}
                                        type='text'
                                        onChange={(e) => setItemDataField({ key: dbFields?.priceOtherCurrency, value: validateDecimals(e), subMethod: 'inputPriceOtherCurrency', })}
                                        onFocus={() => setErrors(prev => ({ ...prev, priceOtherCurrency: '' }))}
                                        placeholder={labels?.priceOtherCurrency?.[languageObj?.id]}
                                        readOnly={isReadOnly}
                                        disabled={process?.showLoading}
                                        value={item?.priceOtherCurrency !== undefined && item?.priceOtherCurrency !== null ? item?.priceOtherCurrency : 0.00} />
                                </div>
                                {errors?.priceOtherCurrency && <div className={settings?.html?.errorText}>{HtmlParser(errors?.priceOtherCurrency || '')}</div>}
                            </div>
                        </div>
                        <div className='col-12 col-md-6'>
                            <div className='form-group mb-4'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.price?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.moneyBillWave} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon text-right'
                                        title={labels?.price?.[languageObj?.id]}
                                        type='text'
                                        placeholder={labels?.price?.[languageObj?.id]}
                                        readOnly={true}
                                        disabled={process?.showLoading}
                                        value={setSeparatorsNumbersNew({ number: item?.price, withDecimals: true, subMethod: 'inputPrice' })?.result || ''} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12 col-md-6'>
                            <div className='form-group mb-4'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.availableQuantity?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.sortNumericUpAlt} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon text-right'
                                        title={labels?.availableQuantity?.[languageObj?.id]}
                                        type='text'
                                        onChange={(e) => setItemDataField({ key: dbFields?.availableQuantity, value: validateDecimals(e), subMethod: 'inputAvailableQuantity', })}
                                        onFocus={() => setErrors(prev => ({ ...prev, availableQuantity: '' }))}
                                        placeholder={labels?.availableQuantity?.[languageObj?.id]}
                                        readOnly={readOnlyAvailableQuantity}
                                        disabled={process?.showLoading}
                                        value={item?.availableQuantity !== undefined && item?.availableQuantity !== null ? item?.availableQuantity : 0} />
                                </div>
                                {errors?.availableQuantity && <div className={settings?.html?.errorText}>{HtmlParser(errors?.availableQuantity || '')}</div>}
                            </div>
                        </div>
                        <div className='col-12 col-md-6'>
                            <div className='form-group mb-4'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.listingTypeId?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.listUl} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                        title={labels?.listingTypeId?.[languageObj?.id]}
                                        type='text'
                                        value={item?.listingTypeId || ''}
                                        placeholder={labels?.listingTypeId?.[languageObj?.id]}
                                        readOnly={true}
                                        disabled={process?.showLoading} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.status?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.toggleOn} position-absolute input-icon-left`} />
                            <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                defaultValue={item?.status ? item?.status : ''}
                                onChange={(e) => changeItemStatus({ statusType: e?.target?.value, subMethod: 'selectStatus', })}
                                placeholder={labels?.status?.[languageObj?.id]}
                                title={labels?.status?.[languageObj?.id]}
                                disabled={process?.showLoading}>
                                {itemStatus.map((detail) => <option key={detail.id} value={detail.id}>{detail.description}</option>)}
                            </select>
                        </div>
                    </div>

                    {showAlert && item.listingTypeId === 'free' ? (
                        <div className='form-group mb-4'>
                            <div className='alert alert-warning text-center shadow-sm border-0' style={{ borderRadius: '10px' }} role='alert'>
                                <i className={`${icons?.fasFa?.exclamationTriangle} mr-2`}></i>{HtmlParser(messages?.freeItemsOnlyAllowOneQuantity?.[languageObj?.id] || '')}
                            </div>
                        </div>)
                        :
                        (<></>)
                    }

                    {item.mlStatus === mercadoLibreSettings?.status.under_review ? (
                        <div className='form-group mb-4'>
                            <div className='alert alert-warning text-center shadow-sm border-0' style={{ borderRadius: '10px' }} role='alert'>
                                <i className={`${icons?.fasFa?.exclamationTriangle} mr-2`}></i>{HtmlParser(messages?.theItemIsInStatusUnderReviewYouMustCorrectTheProblemInTheMercadoLibrePortal?.[languageObj?.id] || '')}
                            </div>
                        </div>
                    ) :
                        (<></>)
                    }

                    {showAlertDelete ? (
                        <div className='form-group mb-4'>
                            <div className='alert alert-danger text-center shadow-sm border-0' style={{ borderRadius: '10px' }} role='alert'>
                                <i className={`${icons?.fasFa?.exclamationTriangle} mr-2`}></i>{HtmlParser(messages?.afterDeletingPublicationThereIsNoGoingBack?.[languageObj?.id] || '')}
                            </div>
                        </div>)
                        :
                        (<></>)
                    }
                    {/* </div> */}

                    {/* <div className='card-footer text-right'> */}
                    {/* <div className='form-group text-right'>
                        <button className='btn btn-outline-warning mx-1'
                            data-title={labels?.save?.[languageObj?.id]}
                            type='submit'
                            //disabled={processValues?.btnSaveDisabled}>
                            disabled={btnSaveDisabled || process?.showLoading}>
                            {!process?.save ? (
                                <i className={icons?.fasFa?.save}></i>
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )}
                        </button>
                        <button className='btn btn-outline-success'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            disabled={process?.showLoading}
                            onClick={() => setShowModal(false)}>
                            <i className={icons?.fasFa?.arrowAltCircleLeft}></i>
                        </button>
                    </div> */}
                    {/* </div> */}
                    {/* </div> */}
                    {/* </form> */}
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4 btn-primary'
                            data-title={labels?.save?.[languageObj?.id]}
                            type='submit'
                            disabled={btnSaveDisabled || process?.showLoading}>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`}></i>
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            disabled={process?.showLoading}
                            onClick={() => setShowModal(false)}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`}></i> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}